import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table, UncontrolledCollapse } from "reactstrap";
import { useEffect, useRef, useState } from "react";
import JedaiTooltip from "../coms/JedaiTooltip";
import { JedaiDateTimeViewText } from "../coms/BlkCalendario";
import axios from "axios";
import { routes } from "../gen/General";

export const ModalInformeImportacion = ({ alert, open, close }) => {
    const [list, setList] = useState([]);
    const id = useRef();

    useEffect(() => {
        if (open) {
            findInfs();
            id.current = setInterval(() => findInfs(), 5000);
        }
        return () => {
            clearInterval(id.current);
        };
    }, [open]);

    const findInfs = () => {
        let url = "/beneficios/importacion-historial";
        axios
            .get(routes.base + url)
            .then(resp => {
                setList(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };

    const deleteInf = id => {
        let url = "/beneficios/importacion-historial/delete/";
        axios
            .get(routes.base + url + id)
            .then(resp => {
                findInfs();
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };

    return (
        <>
            <Modal isOpen={open} size={"xl"}>
                <ModalHeader>
                    Importaciones Realizadas&nbsp;
                    <JedaiTooltip
                        className="icon-info"
                        placement="right"
                        message={
                            "Encontrará un historial de los archivos importados, cada historial permanecerán por un tiempo de tres horas a partir de la hora de creación."
                        }
                    >
                        <i className="fas fa-info-circle" />
                    </JedaiTooltip>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col">
                            <Table responsive striped className="text-center altTable">
                                <thead className="text-primary">
                                    <tr>
                                        <th>#</th>
                                        <th>Archivo</th>
                                        <th>Fc. Importación</th>
                                        <th>Fc. Finalización</th>
                                        <th>Estado</th>
                                        <th>Importados</th>
                                        <th>Actualizados</th>
                                        <th>Errores</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {(list || []).map((job, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{job.name}</td>
                                            <td>
                                                <JedaiDateTimeViewText value={job.fc} complete={true} />
                                            </td>
                                            <td>
                                                {job.done && <JedaiDateTimeViewText value={job.ff} complete={true} />}
                                            </td>
                                            <td>
                                                {job.done ? (
                                                    <span className={""}>Finalizado</span>
                                                ) : (
                                                    <span>
                                                        Importando <i className={"fa-solid fa-spinner fa-spin-pulse"} />
                                                    </span>
                                                )}
                                            </td>
                                            <td>{job.saved || 0}</td>
                                            <td>{job.updated || 0}</td>
                                            <td>
                                                <Button
                                                    className={"btn btn-sm"}
                                                    color={"danger"}
                                                    id={"toggler" + index}
                                                >
                                                    {job.errors?.length || 0}
                                                </Button>
                                                <UncontrolledCollapse toggler={"#toggler" + index}>
                                                    {job.errors?.length > 0 &&
                                                        job.errors?.map((i, idx) => (
                                                            <small key={idx} className={"d-block"}>
                                                                {i}
                                                            </small>
                                                        ))}
                                                </UncontrolledCollapse>
                                            </td>
                                            <td>
                                                {job.done && (
                                                    <div>
                                                        <i
                                                            className="fa fa-trash click c-pointer"
                                                            onClick={() => {
                                                                deleteInf(job.id);
                                                            }}
                                                            title={"Borrar ítem"}
                                                        ></i>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-danger mt-2" onClick={close}>
                        Cerrar
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
};
